module.exports = AMapUI;